import { useTheme } from '@emotion/react';
import { Box, Card, CardContent, CardMedia } from '@mui/material';
import { mediaCardSx } from '../../styles/Global.style';
import { Heading } from '../Heading/Heading';
import { Text } from '../Text/Text';
import {
  colorOverlay,
  headingSx,
  imageCardSx,
  overlayHeadingSx,
} from './ChallengeCard.style';
import { ChallengeDetails } from '../ChallengeDetails/ChallengeDetails';
import { brandOverride } from '../../clients/brandOverride';
import { dynamicChallengeDetails } from '../../helpers/dynamicChallengeDetails';

export const ChallengeCard = ({ leaderboard }) => {
  const theme = useTheme();
  const title = brandOverride().title;

  const detailsArray = dynamicChallengeDetails(
    leaderboard?.totalDistance.total,
  );

  return (
    <Card sx={{ ...mediaCardSx(theme), ...imageCardSx }}>
      <CardMedia
        component="img"
        src="../challenge.webp"
        height="194"
        title={title}
      />

      <Box component="div" sx={colorOverlay(theme)}></Box>

      <Box component="div" sx={overlayHeadingSx}>
        <Heading level={1} text={title} sx={headingSx} />
      </Box>

      <CardContent>
        <Text text={brandOverride().intro} />

        <ChallengeDetails detailsArray={detailsArray} />
      </CardContent>
    </Card>
  );
};
